import {
  changeClientOnDemande,
  getAdresseDepotBySourceDemande,
  getAdresseFacturationData,
  getClient,
  getClientAdresses, getClientContacts,
  getClientDemandeImmat,
  getClientOtherData, getDemandes,
  getProvenancePiece,
  getTypePieceStockValue,
} from '../../../../components/requests'
import {useNavigate, useParams, Link} from 'react-router-dom'
import React, {useEffect, useRef, useState} from 'react'
import {VehicleInfo} from '../Components/VehicleInfo'
import {ListePiece} from '../Components/ListePiece'
import {
  ModeleAdresseDepot,
  ModeleClient,
  ModeleClientContact,
  ModeleClientDemande,
  ModeleClientDemandePiece,
  modeleClientInitValues,
  ModeleClientOtherData,
  modeleClientOtherDataInitValues,
} from '../../../../components/Models'
import {useLocation} from 'react-router'
import {LoadingData} from '../../../../components/LoadingData'
import ClientInfos from '../Components/ClientInfos'
import {toast} from 'react-toastify'
import {usePanier} from './Televendeur/PanierContext'
import {useAuth} from '../../../modules/auth'
import HeaderDemandeTraitement from '../Components/Televendeur/HeaderDemandeTraitement'
import SavCarteDossiers from '../../sav/components/SavCarteDossiers'
import AdresseClient from '../Components/Televendeur/AdresseClient'
import DemandeAssignation from '../Components/Televendeur/DemandeAssignation'
import ResearchClientModal from '../Components/ResearchClientModal'
import ChoixContactModal from '../Components/ChoixContactModal'
import ClientMoreInfos from '../Components/Televendeur/ClientMoreInfos'
import AddClientModal from '../Components/AddClientModal'
import moment from 'moment'
import {useFilAriane} from '../../../contexts/FilArianeContext'
import CardCommentaire from '../Components/Televendeur/CardCommentaire'
import axios from "axios";
import ConfirmVBModal from '../Components/ConfirmVBModal'
import ClientAdresseFormModal from '../../shop/clients/components/ClientAdresseFormModal'
import {
  shouldDisplayFonctionnalite,
  transformToValueLabel,
} from '../../../../components/helpers'
import DemandePj from "../Components/DemandePj";
import {FileWithPreview} from "../../../../components/MutliFilePicker";

type LocationState = {
  panier: any
  redirectToClientDemande: boolean
  showSendedEmailToast: boolean
  emailClotureToast: boolean
  idToastMailSend: any
  isFromPOT: boolean
  isFromClient: boolean
  autoAssign: boolean
  filters: any
  clientId: number | null | undefined
  clientDemandeStatus?: string
  retraitDepot?: any
  commentaireInterne?: any
  idFormattedArr?: any
  demandeClient?: ModeleClientDemande
  pagination: {totalPages: number, currentPage: number, pageSize: number}
  loadedFromPage: number
  loadedToPage: number
  activeFilters: any
}

const API_URL = process.env.REACT_APP_API_URL
const demandePj_url = `${API_URL}/uploads/demandePJ/`

const DemandeTraitement = () => {
  const params = useParams()
  // const clientId: string | undefined = params?.clientId
  const demandeId: any = params?.demandId
  const userConnected = useAuth()
  const {setStatut, setEtape, setPanierAriane, setDemandeAriane, resetFilAriane} = useFilAriane()
  const [immatsArray, setImmatsArray] = useState<
    {
      value: string
      label: string
      centreLabel: string
      marque: string
      modele: string
      vin: string
      datePme?: string
      site?: string | number | null | undefined
    }[]
  >([])
  const [demandeClient, setDemandeClient] = useState<ModeleClientDemande | null>(null)
  const [pieces, setPieces] = useState<Array<ModeleClientDemandePiece>>([])
  const [loadStock, setLoadStock] = useState<boolean>(false)
  const [demandeImmat, setDemandeImmat] = useState<any>([])
  const location = useLocation()
  const [loading, setLoading] = useState(true)
  const [loadingCLientInfo, setLoadingCLientInfo] = useState(false)
  const state = location.state as LocationState | null
  const [isAssign, setIsAssign] = useState<boolean>(false)
  const [immatValid, setImmatValid] = useState<boolean>(true)
  const {panier, setPanier} = usePanier()
  const clientDataRef = useRef<ModeleClient | null>(null)
  const [data, setData] = useState<ModeleClient>(modeleClientInitValues)
  const navigate = useNavigate()
  const [otherData, setOtherData] = useState<ModeleClientOtherData>(modeleClientOtherDataInitValues)
  const [isProspect, setIsProspect] = useState<boolean>(false)
  const [clientAdresses, setClientAdresses] = useState<any>()
  const [showDetailVehicule, setShowDetailVehicule] = useState(false)
  const [panierByStatus, setPanierByStatus] = useState<any>([])
  const [fromListePiece, setFromListePiece] = useState<boolean>(false)
  const [provenances, setProvenances] = useState<any>([])
  const [isLoadingProvenance, setIsLoadingProvenance] = useState<boolean>(false)
  const [updatedAdresseLivInfo, setUpdatedAdresseLivInfo] = useState({
    id: '',
    adresseLiv: '',
    complementAdresseLiv: '',
    telephoneLiv: '',
    cPLiv: '',
    villeLiv: '',
    paysLiv: '',
  })
  const [updatedAdresseFactInfo, setUpdatedAdresseFactInfo] = useState({
    id: '',
    adresseFac: '',
    complementAdresseFac: '',
    telephoneFac: '',
    cPFac: '',
    villeFac: '',
    paysFac: '',
  })
  const [updatedFinalAdresseLivInfo, setUpdatedFinalAdresseLivInfo] = useState({
    id: '',
    adresseLiv: '',
    complementAdresseLiv: '',
    telephoneLiv: '',
    cPLiv: '',
    villeLiv: '',
    paysLiv: '',
  })
  const [updatedFinalAdresseFactInfo, setUpdatedFinalAdresseFactInfo] = useState({
    id: '',
    adresseFac: '',
    complementAdresseFac: '',
    telephoneFac: '',
    cPFac: '',
    villeFac: '',
    paysFac: '',
  })
  const [isAdresseUpdated, setIsAdresseUpdated] = useState<boolean>(false)
  const [adresseFacturation, setAdresseFacturation] = useState<any>([])
  const requierdFieldLiv = ['adresseLiv', 'telephoneLiv', 'cPLiv', 'villeLiv', 'paysLiv']
  const requierdFieldFac = ['adresseFac', 'telephoneFac', 'cPFac', 'villeFac', 'paysFac']
  const [errorsLiv, setErrorsLIv] = useState({})
  const [errorsFac, setErrorsFac] = useState({})
  const [clientId, setClientId] = useState<any>(params?.clientId)
  const [isClientSociety, setIsClientSociety] = useState<boolean>()
  const [demandeSourceValue, setDemandeSourceValue] = useState({
    value: '',
    label: '',
  })
  const [isEdit, setIsEdit] = useState<any>(false)
  const [isConfirmEdit, setIsConfirmEdit] = useState(false)
  const [showMoreClientInfo, setShowMoreClientInfo] = useState<boolean>(false)
  const [radioValue, setRadioValue] = useState<string>('email')
  const [defaultValueContact, setDefaultValueContact] = useState<any>('')
  const [contactedBy, setContactedBy] = useState<any | null>()
  const [contentCommunication, setContentCommunication] = useState<any>()
  const [isDuplicate, setIsDuplicate] = useState<boolean>(false)
  const [tempClientId, setTempClientId] = useState<number | null>(null)
  const [openModalResVeh, setOpenModalResVeh] = useState<boolean>(false)
  const [isCreateViaModal, setIsCreateViaModal] = useState<boolean>(false)
  const [contactedByBloc, setContactedByBloc] = useState<string | null>(null)
  const [tempClient, setTempClient] = useState<any | null>(null)
  const [piecePropData, setPiecePropData] = useState<any>([])
  const [isPrevious, setIsPrevious] = useState<boolean>(true)
  const refRechercheClient = useRef<HTMLButtonElement | null>(null)
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [loadingAdresse, setLoadingAdresse] = useState<boolean>(false)
  const [retraitDepot, setRetraitDepot] = useState<boolean>(state?.retraitDepot ?? false)
  const [commentaireInterne, setCommentaireInterne] = useState<string>(state?.commentaireInterne ?? '')
  const [initialPieces, setInitialPieces] = useState<any[]>([])
  const [totalLibelle, setTotalLibelle] = useState<number>(0)
  const [adresseDepots, setAdresseDepots] = useState<Array<ModeleAdresseDepot>>([])
  const [loadingDepot, setLoadingDepot] = useState<boolean>(false)

  // Adresse de facturation / livraison > Création / Modification depuis Fiche client
  const [clientAdresseData, setClientAdresseData] = useState<any>(null)
  const [clientAdresseEdit, setClientAdresseEdit] = useState<any>(null)
  const [refetchClientData, setRefetchClientData] = useState<boolean>(false)
  const [livraisonSelectedValue, setLivraisonSelectedValue] = useState({value: '', label: ''})
  const [facturationSelectedValue, setFacturationSelectedValue] = useState({value: '', label: ''})
  const [clientContacts, setClientContacts] = useState<ModeleClientContact[]>([])
  const {currentUser} = useAuth()
  const currentIndex = (state?.idFormattedArr ?? []).findIndex((i) => i?.demandeId == demandeId) ?? 0
  const [images, setImages] = useState<FileWithPreview[]>([]) // PJ demande

  const abortController = useRef<AbortController | null>(null)

  // Récupération des données clients
  const getClientData = (clientId) => {
    setLoadingCLientInfo(true)

    if (clientDataRef.current) {
      setData(clientDataRef.current)
      setLoadingCLientInfo(false)
      return
    }
    getClient(clientId).then((res) => {
      if (res?.status === 200 && res?.data?.id) {
        const updatedData = {...res.data}
        updatedData.idPays = updatedData.pays?.id
        clientDataRef.current = updatedData
        setData(updatedData)
        // Récup. des données suppl.
        getClientDataOthers()
        getAdresseFacturation()
        if (updatedData.typeClient === 'PROSPECT') {
          setIsProspect(true)
        }
      } else {
        navigate('/vente/clients/liste')
      }
    })

    // Récuperation des contacts du client
    getClientContacts(clientId).then((res) => {
      if (res?.status === 200 && res?.data !== undefined) {
        setClientContacts(res?.data)
      }
    })
  }
  const getClientDataOthers = () => {
    getClientOtherData(clientId, demandeId).then((clientRequest) => {
      if (clientRequest?.status === 200) {
        const updatedData = Object.assign({...data}, clientRequest?.data)
        setOtherData({...updatedData})
        setLoadingCLientInfo(false)
      }
    })
  }

  const getAdresseFacturation = () => {
    getAdresseFacturationData(clientId).then((adresseRequest) => {
      if (adresseRequest?.status === 200) {
        setAdresseFacturation(adresseRequest?.data)
      }
    })
  }

  useEffect(() => {
    getClientData(clientId)
    getAllClientAdresses(clientId)
  }, [clientId])

  const getDemande = () => {
    let centreIds: string | undefined = ''
    if (userConnected) {
      let userCentre = userConnected?.currentUser?.listeCentres?.[0]
      if (userCentre?.length > 0) centreIds = userCentre?.map((centre) => centre?.id)?.join(',')
    }

    getClientDemandeImmat(demandeId, centreIds).then((clientDemandeReq) => {
      if (clientDemandeReq?.status == 200 && clientDemandeReq?.data != undefined) {

        //get demandePJ
        const newFiles: any = Array.from(clientDemandeReq?.data?.pjDemande ?? []).map((fileObjet:any) => ({
          id: crypto.randomUUID(), // Évite les bugs d'index lors des suppressions
          file: {
            name: fileObjet?.name,
            type: fileObjet?.type,
          },
          preview: `${demandePj_url}${fileObjet?.name}`, // url d'images demandePJ enrégistrer dans le projet
        }))
        setImages(newFiles)

        const dataDemandeImmat: any[] = [...clientDemandeReq.data.clientDemandeImmat]
        setDemandeImmat(clientDemandeReq.data.clientDemandeImmat)
        setDemandeClient(clientDemandeReq.data?.demande)
        setRetraitDepot(state?.retraitDepot ?? clientDemandeReq.data?.demande?.retraitDepot ?? false)
        setCommentaireInterne(clientDemandeReq.data?.demande?.commentaire ?? '')
        setDemandeSourceValue({
          value: clientDemandeReq.data?.demande?.demandeSource?.id,
          label: clientDemandeReq.data?.demande?.demandeSource?.name,
        })
        clientDemandeReq.data.clientDemandePiece.forEach((demande) => {
          demande.stock = 'chargement'
        })
        setPieces(clientDemandeReq.data.clientDemandePiece)
        setLoadStock(true)
        clientDemandeReq.data.clientDemandeImmat.length == 0
          ? setImmatValid(false)
          : setImmatValid(true)

        if (dataDemandeImmat.length != 0) {
          dataDemandeImmat?.map((item) => {
            const immat: string = item?.immatriculation ?? ''
            const exists: boolean = immatsArray.some((existingItem) => existingItem.value === immat)
            if (!exists) {
              setImmatsArray((prevArray) => {
                let mar = ''
                let mod = ''
                let site = clientDemandeReq?.data?.site
                  ?.find((clientDemande) => clientDemande?.id === item?.id)?.site
                  ?.toString() ?? null

                if (item?.modele) {
                  mar = item.modele?.marque?.nom ?? ''
                  mod = item.modele?.nom ?? ''
                } else if (item?.vehiculeHorsType) {
                  mar = item.vehiculeHorsType?.marque ?? ''
                  mod = item.vehiculeHorsType?.nom ?? ''
                } else if (item?.donneesImmatriculation) {
                  mar = item.donneesImmatriculation?.smarque ?? ''
                  mod = item.donneesImmatriculation?.smodele ?? ''
                }

                //marque et modèle ajouter au label immatriculation
                let labelMarqMod = ''
                if (item.donneesImmatriculation?.smarque) {
                  labelMarqMod = ' - ' + item.donneesImmatriculation?.smarque ?? ''
                }
                if (item.donneesImmatriculation?.smodele) {
                  labelMarqMod += ' - ' + item.donneesImmatriculation?.smodele ?? ''
                }

                // Ajoute une nouvelle immat si elle n'existe pas
                return [
                  // ...prevArray,
                  {
                    value:
                      item?.modele || item?.vehiculeHorsType
                        ? mar + ' - ' + mod + (item?.vehiculeHorsType ? ' [VHT]' : '')
                        : item?.immatriculation ?? '',
                    label:
                      item?.modele || item?.vehiculeHorsType
                        ? mar + ' - ' + mod + (item?.vehiculeHorsType ? ' [VHT]' : '')
                        : item?.immatriculation
                          ? item?.immatriculation + labelMarqMod
                          : '',
                    centreLabel: item?.centre?.nom ?? '',
                    marque: mar,
                    modele: mod,
                    idModele: item?.modele ? item?.modele?.id : null,
                    idHorsType: item?.vehiculeHorsType ? item?.vehiculeHorsType?.id : null,
                    immatriculationNonTrouvee: item?.immatriculationNonTrouvee ?? null,
                    vin: item?.donneesImmatriculation?.sVin,
                    datePme: item?.donneesImmatriculation?.sdatePme
                      ? moment(item.donneesImmatriculation.sdatePme).format('DD/MM/YYYY')
                      : '',
                    site
                  },
                ]
              })
            }
          })
        }
        setLoading(false)
      }
    })
  }

  const getAdresseRetraitDepot = async (source: string) => {
    setLoadingDepot(true)

    if (abortController.current) {
      abortController.current.abort()
    }
    const controller = new AbortController()
    abortController.current = controller

    try {
      const res = await getAdresseDepotBySourceDemande(source, controller.signal)
      if (res.data)
        setAdresseDepots(res.data)
    } catch (e) {
      if (axios.isAxiosError(e) && e.code === 'ERR_CANCELED') {
        return
      }
      console.error(e)
    } finally {
      if (abortController.current === controller) {
        setLoadingDepot(false)
      }
    }
  }

  useEffect(() => {
    getDemande()
  }, [demandeId])

  useEffect(() => {
    if (panier?.length > 0) setPanierAriane(panier)
    if (demandeClient) setDemandeAriane(demandeClient)
    else resetFilAriane()

    const etape = demandeClient?.clientDemandeEtape?.code
    if (!etape) return;

    setEtape(etape)

    if (demandeClient?.intervention) setStatut("INTERVENTION")
    else if (etape === "REFUS") setStatut("REFUSE")
    else if (etape === "BLOQU") setStatut("ACCEPTEE BLOQUE")
    else if (etape === "MODIF") setStatut("MODIFIEE")
    else if (etape === "ECHEC") setStatut("ACCEPTEE INDISPONIBLE")
    else if (etape === "INDIS") setStatut("INDISPONIBLE")
    else setStatut("")
  }, [panier, demandeClient]);

  // Pour obtenir le stock de chaque type pièce durant le traitement et pour controller l'arret de la requete
  useEffect(() => {
    const controller = new AbortController()
    const signal = controller.signal

    if (loadStock) {
      pieces.forEach(async (demande, index) => {
        let stock = 0
        let ref = demande.refConst ?? ''
        let isHorsType = demande.clientDemandeImmat.vehiculeHorsType

        if (demande?.typePiece?.id) {
          await getTypePieceStockValue(
            demande.typePiece.id,
            ref,
            isHorsType !== null ? '' : demande.marque,
            isHorsType !== null ? '' : demande.modele,
            signal
          ).then((res) => (stock = res?.data[0]))
        }

        setPieces((prevTypePiece) => {
          const updatedTypePiece = [...prevTypePiece]
          updatedTypePiece[index] = {...updatedTypePiece[index], stock}
          return updatedTypePiece
        })
      })
    }

    return () => controller.abort()
  }, [loadStock, setLoadStock])

  useEffect(() => {
    if (state?.showSendedEmailToast) {
      toast.success('Envoi des propositions terminé  avec succès.', {
        hideProgressBar: true,
        autoClose: 2000,
      })
    } else if (state?.emailClotureToast) {
      toast.success('La pièce a été marquée comme non disponible.', {
        hideProgressBar: true,
        autoClose: 2000,
      })
    }
  }, [location.state])

  const showToastPOT = () => {
    toast.success(`Pièce d'occasion taxable modifiée avec succès.`, {
      hideProgressBar: true,
      autoClose: 2000,
    })
  }

  const getAllClientAdresses = (clientId) => {
    setLoadingAdresse(true)
    getClientAdresses(clientId).then((res) => {
      if (res.status === 200) {
        setLoadingAdresse(false)
        setClientAdresses(res.data)
      }
    })
  }

  // Gestion de redirection pour le bouton retour
  const linkToPreviousPage = () => {
    if (state?.isFromClient) {
      return `/vente/clients/${clientId}/afficher/demandClient`
    } else {
      if (state?.isFromClient == undefined) {
        return '/demandes/liste'
      }
      if (state?.redirectToClientDemande) {
        return '/demandes/liste'
      }
    }
    // FallBack
    return '/'
  }

  const getAllProvenancePiece = () => {
    getProvenancePiece().then((res) => {
      setIsLoadingProvenance(true)
      if (res.status === 200 && res.data) {
        const transformedData = res.data.map((item) => ({
          value: item.id,
          label: item.libelle,
        }))
        setProvenances([...transformedData])
        setIsLoadingProvenance(false)
      } else {
        console.error('Erreur lors de la récupération des données')
        setIsLoadingProvenance(false)
      }
    })
  }

  useEffect(function fetchProvenances() {
    getAllProvenancePiece()
  }, [])

  // // Relance de récuperation provenances s'il n'y a pas de provenance dans locationState
  // useEffect(() => {
  //   if (state?.provenances?.length == 0 || state?.provenances == undefined) {
  //     getAllProvenancePiece()
  //   } else {
  //     setProvenances(state?.provenances)
  //   }
  // }, [state?.provenances])

  useEffect(
    function changeUrlParamsFromListePieceStock() {
      if (state?.clientId != null && state?.clientId != clientId) {
        setClientId(state?.clientId)
      }
    },
    [state?.clientId]
  )

  const handleUpdateClientData = (tempClientId, radioValue, tempContactedBy, communicationMode) => {
    setIsConfirmEdit(true)
    clientDataRef.current = null
    setClientId(tempClientId)
    changeClientOnDemande(
      tempClientId,
      demandeId,
      radioValue,
      tempContactedBy,
      communicationMode,
      panier.map(p => p.idPiecePropose)
    ).then((res) => {
      if (res?.status !== 200) {
        console.error('Erreur lors de la changement de client')
      } else {
        navigate(`/demandes/${tempClientId}/traitement/${demandeId}`, {replace: true}) // Changement de l'id du client dans l'url
        setDemandeClient(res?.data.demande)
        setPiecePropData(res?.data?.panier)

        const demande = res?.data?.demande;
        const client = res?.data?.client;

        setRetraitDepot(demande?.retraitDepot);

        // Mise à jour du panier avec le taux de remise du nouveau client
        const finalPanier = panier?.map((piece) => {
          const responsePanier = res?.data?.panier;
          const pieceResponsePanier = responsePanier?.find((panier) => panier?.id === piece?.idPiecePropose);

          // TVA POT toujours 20%
          const isProfessionnel = piece?.isTypePiecePOT ? 20 : ((client && client?.professionnel === false) ? 10 : 20);
          const fraisDePort = (demande?.retraitDepot) ? 0 : (Number(pieceResponsePanier?.prixTransport) ?? 0);
          const fraisDePortInitial = Number(pieceResponsePanier?.prixTransport) ?? 0;

          const taux = Number(pieceResponsePanier?.tauxRemise ?? 0);
          const tauxTva = Number(piece?.tauxTva ?? 0);
          const prix = Number(piece?.prix ?? 0);

          const prixReferentielTtc = Number(prix * (1 + (tauxTva / 100))) ?? 0;
          const prixReferentielHtInitial = Number(prixReferentielTtc / (1 + (isProfessionnel / 100))) ?? 0;
          const prixReferentielHt = Number(pieceResponsePanier?.prixReferentiel) ?? 0;

          const prixVenteProposeeHt = Number(prixReferentielHt - (prixReferentielHt * (taux / 100)));
          const prixVenteProposeeTtc = Number(prixVenteProposeeHt * (1 + (isProfessionnel / 100))) ?? 0;
          const roundedPrixVenteProposeeTtc = Math.floor(prixVenteProposeeTtc * 100) / 100;

          return {
            ...piece,
            tauxRemise: Number(taux?.toFixed(1)),
            montantRemise: Number((prixReferentielHt - prixVenteProposeeHt).toFixed(2)),
            prixReferentielHtInitial: Number(prixReferentielHtInitial?.toFixed(2)),
            prixReferentielHt: Number(prixReferentielHt?.toFixed(2)),
            prixReferentielTtc: Number(prixReferentielTtc?.toFixed(2)),
            prixVenteProposeeHt: Number(prixVenteProposeeHt?.toFixed(2)),
            prixVenteProposeeTtc: Number(roundedPrixVenteProposeeTtc?.toFixed(2)),
            fraisDePort: Number(fraisDePort?.toFixed(2)),
            fraisDePortInitial: Number(fraisDePortInitial?.toFixed(2))
          }
        });
        setPanier(finalPanier)

        if (finalPanier && initialPieces.length === 0) {
          const copieInitiale = finalPanier
            .filter((p) => p.statut === 'PROPO')
            .map((p) => {
              return {
                id: p.id,
                tauxRemise: Number(p?.tauxRemise ?? 0),
                montantRemise: Number(p?.montantRemise ?? 0),
                fraisDePort: Number(p.fraisDePort ?? 0),
                fraisDePortInitial: Number(p.fraisDePort ?? 0),
                prixReferentielHt: Number(p?.prixReferentielHt ?? 0),
                prixReferentielTtc: Number(p?.prixReferentielTtc ?? 0),
                prixVenteProposeeHt: Number(p?.prixVenteProposeeHt ?? 0),
                prixVenteProposeeTtc: Number(p?.prixVenteProposeeTtc ?? 0)
              }
            })
          setInitialPieces(copieInitiale)
        }
      }
    })
  }

  // Setter la valeur de duplicate en false
  const toggleDuplicate = () => {
    setIsDuplicate(false)
  }

  // Pour mettre à jour la demande après validation d'un virement bancaire
  const updDemande = (stat: string, demande: ModeleClientDemande) => {
    // ne pas effacer stat
    setDemandeClient(demande)
  }

  // Pour gérer le switch entre les demandes
  const goToDemande = (dm: {demandeId: number, clientId: number, demande?: ModeleClientDemande}, nextState: any = state) => {
    setLoading(true)
    navigate(
      `/demandes/${dm.clientId}/traitement/${dm.demandeId}`,
      {
        state: {
          ...nextState,
          demandeClient: dm.demande,
        },
      }
    )
  }

  const fetchPage = async (page: number) => {
    const controller = new AbortController()
    abortController.current = controller

    //les centres de l'utilisateur connectés
    const userConnectedCentres = currentUser?.listeCentres ?? []
    let userConnectedCentresString: any = []
    if (userConnectedCentres.length) {
      userConnectedCentresString = userConnectedCentres
        .flat()
        .map((c) => c.id)
        .join(',')
    }

    try {
      const response = await getDemandes(
        page,
        state?.activeFilters['searchPage'],
        state?.activeFilters['statut'],
        state?.activeFilters['statusMode'] ?? 'DEMANDE',
        state?.activeFilters['source'],
        null,
        state?.activeFilters['dateDebut'],
        state?.activeFilters['dateFin'],
        state?.activeFilters['equipes'],
        userConnectedCentresString,
        null,
        state?.activeFilters['allDemandes'],
        state?.activeFilters['searchId'],
        state?.activeFilters['tri'],
        state?.activeFilters['itemPerPage'],
        controller.signal
      )
      if (response?.status !== 200 || !response?.data) {
        return []
      }

      const { data } = response.data

      if (!Array.isArray(data)) {
        return []
      }

      return data.flatMap((item) => {
        const demande = item?.[0]
        const id = demande?.id
        const clientId = demande?.client?.id

        if (id == null || clientId == null) {
          return []
        }

        return [{ clientId, demandeId: id, demandeClient: demande }]
      })
    } catch (error: unknown) {
      if (axios.isCancel(error)) {
        return []
      }

      console.error('Erreur lors du chargement des demandes :', error)
      return []
    } finally {
      setLoading(false)
    }
  }

  const handlePrevious = async () => {
    if (loading || currentIndex < 0) return

    const idFormattedArr = state?.idFormattedArr ?? []

    // Une demande précédente existe déjà en mémoire
    if (currentIndex > 0) {
      goToDemande(idFormattedArr[currentIndex - 1])
      return
    }

    const firstPage = state?.loadedFromPage
      ?? state?.pagination?.currentPage

    // Aucune page précédente disponible
    if (!firstPage || firstPage <= 1) return

    setLoading(true)

    try {
      const previousData = await fetchPage(firstPage - 1)

      if (previousData.length === 0) return

      const updatedArr = [
        ...previousData,
        ...idFormattedArr,
      ]

      goToDemande(previousData[previousData.length - 1], {
        ...state,
        idFormattedArr: updatedArr,
        loadedFromPage: firstPage - 1,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleNext = async () => {
    if (loading || currentIndex < 0) return

    const idFormattedArr = state?.idFormattedArr ?? []

    // Une demande suivante existe déjà en mémoire
    if (currentIndex < idFormattedArr.length - 1) {
      goToDemande(idFormattedArr[currentIndex + 1])
      return
    }

    const lastPage = state?.loadedToPage ?? state?.pagination?.currentPage

    // Aucune page suivante disponible
    if (!lastPage || lastPage >= (state?.pagination?.totalPages ?? 0) || currentIndex + 1 == state?.pagination?.totalPages) {
      return
    }

    setLoading(true)

    try {
      const nextData = await fetchPage(lastPage + 1)

      if (nextData.length === 0) return

      const updatedArr = [...idFormattedArr, ...nextData]
      goToDemande(nextData[0], {
        ...state,
        idFormattedArr: updatedArr,
        loadedToPage: lastPage + 1,
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {!loading && (
        <>
          {!shouldDisplayFonctionnalite(currentUser, 'REASSIGNER DEMANDE') &&
            shouldDisplayFonctionnalite(currentUser, 'NAVIGUER TRAITEMENT') && (
              <div>
                {/* Flèche Précédent */}
                {!(currentIndex == 0 && state?.pagination?.currentPage == 1) && (
                  <button
                    className='btn btn-primary'
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '110px',
                      transform: 'translateY(-50%)',
                      zIndex: 10,
                      opacity: 0.7,
                    }}
                    onClick={handlePrevious}
                    disabled={loading}
                  >
                    <i className='fa fa-arrow-left'></i>
                  </button>
                )}

                {/* Flèche Suivant */}
                {((state?.pagination?.currentPage ?? 1) - 1) *
                  (state?.activeFilters?.itemPerPage ?? 25) +
                  currentIndex +
                  1 !=
                  state?.pagination?.totalPages && (
                  <button
                    className='btn btn-primary'
                    style={{
                      position: 'absolute',
                      top: '50%', // Mi-hauteur de l'écran
                      right: '15px',
                      transform: 'translateY(-50%)',
                      zIndex: 10,
                      opacity: 0.7,
                    }}
                    onClick={handleNext}
                    disabled={loading}
                  >
                    <i className='fa fa-arrow-right'></i>
                  </button>
                )}
              </div>
            )}
          <div className='d-flex align-items-center justify-content-between mb-3'>
            <div>
              <Link
                to={linkToPreviousPage()}
                // state={{
                //   filters: getValidFilters(state),   // vide si B a été rechargée
                //   appInstance: APP_INSTANCE_ID,
                // }}
                data-tooltip-id='tooltip'
                data-tooltip-content='Revenir en arrière'
                data-tooltip-place='right'
                className='btn btn-light'
                title='Retour'
              >
                <i className='ki-duotone ki-arrow-left fs-3'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
                Retour
              </Link>
              <span>
                {((state?.pagination?.currentPage ?? 1) - 1) *
                  (state?.activeFilters?.itemPerPage ?? 25) +
                  currentIndex +
                  1}{' '}
                / {state?.pagination?.totalPages}
              </span>
            </div>
            <DemandeAssignation
              data={demandeClient}
              setDemandeClient={setDemandeClient}
              demandeClient={demandeClient}
              setIsAssign={setIsAssign}
            />
          </div>
          <div className='card mb-2 border'>
            {loadingCLientInfo ? (
              <LoadingData />
            ) : (
              <>
                <div className='d-flex flex-column flex-lg-row justify-content-between'>
                  <ClientInfos
                    clientData={clientDataRef.current}
                    demandeId={demandeId}
                    otherData={otherData}
                    loadingCLientInfo={loadingCLientInfo}
                    isProspect={isProspect}
                    clientAdresses={clientAdresses}
                    contactedBy={null}
                    clientDemandeStatus={
                      state?.clientDemandeStatus ??
                      demandeImmat?.[0]?.clientDemande?.clientDemandeEtape?.code
                    }
                    setClientAdresseEdit={setClientAdresseEdit}
                    refetchClientData={refetchClientData}
                    setRefetchClientData={setRefetchClientData}
                  />
                  <HeaderDemandeTraitement
                    demandeId={demandeId}
                    data={demandeClient}
                    setIsAssign={setIsAssign}
                    redirectToClientDemande={state?.redirectToClientDemande}
                    onEdit={false}
                    autoAssign={state?.autoAssign}
                    setDemandeClient={setDemandeClient}
                    demandeClient={demandeClient}
                    canCreate={shouldDisplayFonctionnalite(currentUser, 'AJOUTER DEMANDE')}
                  />
                </div>
                {/*Affichage "Plus d'informations"*/}
                <ClientMoreInfos
                  otherData={otherData}
                  demandeId={demandeId}
                  demandeClient={demandeClient}
                  clientData={clientDataRef.current}
                  isConfirmEdit={false}
                  contactedBy={contactedBy}
                  contactedByBloc={contactedByBloc}
                  setContactedByBloc={setContactedByBloc}
                  contentCommunication={''}
                  showMoreClientInfo={showMoreClientInfo}
                  setShowMoreClientInfo={setShowMoreClientInfo}
                />
                {/*Affichage "Adresse Facturation/Livraison"*/}
                <AdresseClient
                  clientData={clientDataRef.current}
                  clientAdresses={clientAdresses}
                  contactedBy={null}
                  updatedAdresseLivInfo={updatedAdresseLivInfo}
                  setUpdatedAdresseLivInfo={setUpdatedAdresseLivInfo}
                  updatedAdresseFactInfo={updatedAdresseFactInfo}
                  setUpdatedAdresseFactInfo={setUpdatedAdresseFactInfo}
                  isAdresseUpdated={isAdresseUpdated}
                  setIsAdresseUpdated={setIsAdresseUpdated}
                  errorsFac={errorsFac}
                  errorsLiv={errorsLiv}
                  fromDemandeForm={false}
                  loadingAdresse={loadingAdresse}
                  retraitDepot={retraitDepot}
                  setRetraitDepot={setRetraitDepot}
                  setPanier={setPanier}
                  setInitialPieces={setInitialPieces}
                  loadingDepot={loadingDepot}
                  setClientAdresseEdit={setClientAdresseEdit}
                  livraisonSelectedValue={livraisonSelectedValue}
                  setLivraisonSelectedValue={setLivraisonSelectedValue}
                  facturationSelectedValue={facturationSelectedValue}
                  setFacturationSelectedValue={setFacturationSelectedValue}
                  clientAdresseData={clientAdresseData}
                />
              </>
            )}
          </div>
        </>
      )}

      {/*Affichage des pièces jointes demande*/}
      {images?.length > 0 && (
        <div className='card p-5 rounded-1 mb-xl-10'>
          <DemandePj images={images} setImages={setImages} isTraitementDemande={true} />
        </div>
      )}

      <div className='card mb-xl-10 border'>
        <div className='card-body p-5'>
          {loading ? (
            <LoadingData />
          ) : immatValid ? (
            <>
              <div className=' d-flex flex-column gap-5'>
                <div>
                  <VehicleInfo
                    demandeId={demandeId}
                    clientId={clientId}
                    immatsArray={immatsArray}
                    data={demandeClient}
                    isAssign={isAssign}
                    setAssign={setIsAssign}
                    redirectToClientDemande={state?.redirectToClientDemande}
                    onEdit={false}
                    setImmatsArray={setImmatsArray}
                    setShowDetailVehicule={setShowDetailVehicule}
                    showDetailVehicule={showDetailVehicule}
                    fromTraitement={true}
                    isFromClient={state?.isFromClient}
                    canEdit={shouldDisplayFonctionnalite(currentUser, 'MODIFIER DEMANDE')}
                  />
                </div>
                <div>
                  <ListePiece
                    pieces={pieces}
                    setPieces={setPieces}
                    demandeImmat={demandeImmat}
                    immatsArray={immatsArray}
                    isAssign={isAssign}
                    piecesProps={pieces}
                    setPiecesProps={setPieces}
                    setPanier={setPanier}
                    panier={panier}
                    demandeEtape={demandeClient?.clientDemandeEtape?.code}
                    redirectToClientDemande={state?.redirectToClientDemande}
                    isFromPOT={state?.isFromPOT}
                    isFromClient={state?.isFromClient}
                    setDemandeClient={setDemandeClient}
                    dataClientInfos={clientDataRef.current}
                    otherData={otherData}
                    isProspect={isProspect}
                    showToastPOT={showToastPOT}
                    clientAdresses={clientAdresses}
                    demandeClient={demandeClient}
                    filters={state?.filters}
                    loadingCLientInfo={loadingCLientInfo}
                    panierByStatus={panierByStatus}
                    setPanierByStatus={setPanierByStatus}
                    fromListePiece={fromListePiece}
                    setFromListePiece={setFromListePiece}
                    provenances={provenances}
                    isLoadingProvenance={isLoadingProvenance}
                    isAdresseUpdated={isAdresseUpdated}
                    adresseFacturation={adresseFacturation}
                    errorsFac={errorsFac}
                    setErrorsFac={setErrorsFac}
                    requierdFieldFac={requierdFieldFac}
                    errorsLiv={errorsLiv}
                    setErrorsLIv={setErrorsLIv}
                    requierdFieldLiv={requierdFieldLiv}
                    setIsAdresseUpdated={setIsAdresseUpdated}
                    updatedFinalAdresseLivInfo={updatedFinalAdresseLivInfo}
                    setUpdatedFinalAdresseLivInfo={setUpdatedFinalAdresseLivInfo}
                    updatedFinalAdresseFactInfo={updatedFinalAdresseFactInfo}
                    setUpdatedFinalAdresseFactInfo={setUpdatedFinalAdresseFactInfo}
                    contactedByBloc={contactedByBloc}
                    setContactedByBloc={setContactedByBloc}
                    clientDemandeStatus={
                      state?.clientDemandeStatus == undefined
                        ? demandeClient?.clientDemandeEtape?.code
                        : state?.clientDemandeStatus
                    }
                    piecePropData={piecePropData}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    refetchClientAdresses={getAllClientAdresses}
                    loadingAdresse={loadingAdresse}
                    retraitDepot={retraitDepot}
                    setRetraitDepot={setRetraitDepot}
                    initialPieces={initialPieces}
                    setInitialPieces={setInitialPieces}
                    totalLibelle={totalLibelle}
                    setTotalLibelle={setTotalLibelle}
                    getAdresseRetraitDepot={getAdresseRetraitDepot}
                    adresseDepots={adresseDepots}
                    loadingDepot={loadingDepot}
                    commentaireInterne={commentaireInterne}
                    setCommentaireInterne={setCommentaireInterne}
                    livraisonSelectedValue={livraisonSelectedValue}
                    setLivraisonSelectedValue={setLivraisonSelectedValue}
                    facturationSelectedValue={facturationSelectedValue}
                    setFacturationSelectedValue={setFacturationSelectedValue}
                    clientAdresseData={clientAdresseData}
                    clientContacts={clientContacts}
                    imagesDemandePj={images} //images demande PJ
                    setUpdatedAdresseLivInfo={setUpdatedAdresseLivInfo}
                    setUpdatedAdresseFactInfo={setUpdatedAdresseFactInfo}
                    currentUser={currentUser}
                  />
                </div>
              </div>
            </>
          ) : (
            <div className='text-center'>Aucun résultat associé à l'immatriculation</div>
          )}
        </div>
      </div>

      <SavCarteDossiers clientDemandeId={demandeId} />

      {!loading && (
        <div>
          <CardCommentaire
            idClientDemande={demandeId}
            clientId={clientId}
            client={demandeClient?.client}
            dataAction={{
              assigneeA: demandeClient?.utilisateurAssigne,
              client: demandeClient?.client,
              commentaire: '',
              dateEcheance: moment().format('YYYY-MM-DD'),
              demande: demandeClient,
              demandeId: demandeClient?.id,
              clientId: demandeClient?.client?.id,
              origine: 'Manuelle',
              prioritaire: false,
              userAssign: demandeClient?.utilisateurAssigne?.id,
            }}
            setDemandeClient={setDemandeClient}
          />
        </div>
      )}

      {/*Modal affichage changement de client*/}
      <ResearchClientModal
        setClientId={setClientId}
        clientId={clientId}
        setTempClientId={setTempClientId}
        setIsClientSociety={setIsClientSociety}
        setIsCreateViaModal={setIsCreateViaModal}
        defaultValueContact={null}
        demandeSources={null}
        sourceLoader={null}
        choicedDemandeSource={demandeSourceValue}
        setChoicedDemandeSource={null}
        transformedSource={null}
        isEdit={true}
        handleUpdateClientData={handleUpdateClientData}
        setTempClient={setTempClient}
        refRechercheClient={refRechercheClient}
        isPrevious={isPrevious}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />

      {/*Modal choix de contact client*/}
      <ChoixContactModal
        clientId={clientId}
        setDefaultValueContact={setDefaultValueContact}
        defaultValueContact={defaultValueContact}
        isFromAddClientContact={null}
        setIsFromAddClientContact={null}
        setRadioValue={setRadioValue}
        isClientSociety={isClientSociety}
        isFromClientList={false}
        contactedBy={contactedBy}
        setContactedBy={setContactedBy}
        radioValue={radioValue}
        setContentCommunication={setContentCommunication}
        contentCommunication={contentCommunication}
        isDuplicate={isDuplicate}
        setIsDuplicate={setIsDuplicate}
        toggleDuplicate={toggleDuplicate}
        isEdit={true}
        handleUpdateClientData={handleUpdateClientData}
        tempClientId={tempClientId}
        contactedByBloc={contactedByBloc}
        setContactedByBloc={setContactedByBloc}
        demandeId={demandeId}
        refRechercheClient={refRechercheClient}
        setIsPrevious={setIsPrevious}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      {/*Modal création de client*/}
      <AddClientModal
        setClientId={setClientId}
        setOpenModalResVeh={setOpenModalResVeh}
        isCreateViaModal={isCreateViaModal}
        openModalResVeh={openModalResVeh}
        fromChangeClient={true}
        setTempClientId={setTempClientId}
      />
      <ConfirmVBModal
        demande={demandeClient}
        handleList={updDemande}
        setDemandeClient={setDemandeClient}
        setPanier={setPanier}
      />
      {/*modal ajout d'adresse pour le client selectionné*/}
      <ClientAdresseFormModal
        clientId={clientId}
        clientAdresses={clientAdresses}
        setClientAdresses={setClientAdresses}
        clientAdresseEdit={clientAdresseEdit}
        setRefetchClientData={setRefetchClientData}
        setClientAdresseData={setClientAdresseData}
        isFromFicheClient={true}
      />
    </>
  )
}
export {DemandeTraitement}
